export default "__VITE_ASSET__BJxZHOxP__"